const _excluded = ["mediaUrl", "mediaAlt", "layout", "imageFit", "bordered", "style", "anchor"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import styled from 'styled-components';
import { componentsThemeMap, colorToVariable } from '../../componentsThemeMap.js';
import { ANALYTICS_KEY } from '../../constants.js';
import { SectionComponentLayout } from '../../layout/SectionComponentLayout.js';
import { TwoColumnLayout } from '../../layout/TwoColumnLayout.js';
import { AnalyticsProvider } from '../../providers/AnalyticsProvider.js';
import '../../ui/Div/index.js';
import { ErrorBoundary } from '../../ui/ErrorBoundary.js';
import { LinkPressable } from '../../ui/Link/LinkPressable.js';
import '../../ui/media/index.js';
import { HeroFeaturedEditorialContent } from './Content.js';
import { jsx } from 'react/jsx-runtime';
import { Media } from '../../ui/media/Lazymedia.js';
import { Div } from '../../ui/Div/Div.js';
const DEFAULT_ALT_TEXT = 'Hero image';
function HeroFeaturedEditorial(_ref) {
  let mediaUrl = _ref.mediaUrl,
    mediaAlt = _ref.mediaAlt,
    layout = _ref.layout,
    _ref$imageFit = _ref.imageFit,
    imageFit = _ref$imageFit === void 0 ? 'cover' : _ref$imageFit,
    _ref$bordered = _ref.bordered,
    bordered = _ref$bordered === void 0 ? false : _ref$bordered,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? 'default' : _ref$style,
    anchor = _ref.anchor,
    contentProps = _objectWithoutProperties(_ref, _excluded);
  const background = componentsThemeMap[style].background;
  const animationColor = background === 'primary' ? 'background' : 'primary';
  const textContent = /*#__PURE__*/jsx(HeroFeaturedEditorialContent, _objectSpread(_objectSpread({}, contentProps), {}, {
    layout: layout,
    style: style
  }));
  const imageContent = /*#__PURE__*/jsx(LinkPressable, {
    href: contentProps.url || '',
    width: "100%",
    "data-qa": ANALYTICS_KEY.SecondaryImage,
    children: /*#__PURE__*/jsx(Media, {
      mediaType: "image",
      priority: true,
      loading: "eager",
      alt: mediaAlt || DEFAULT_ALT_TEXT,
      src: mediaUrl,
      maxHeight: {
        sm: 419,
        md: 'none'
      },
      imageFit: imageFit,
      className: IMAGE_CLASS,
      bordered: bordered,
      overflow: "hidden"
    })
  });
  return /*#__PURE__*/jsx(ErrorBoundary, {
    children: /*#__PURE__*/jsx(AnalyticsProvider, {
      analyticsPrefix: "HeroFeaturedEditorial",
      children: /*#__PURE__*/jsx(SectionComponentLayout, {
        as: "header",
        hasSpacingHorizontal: true,
        background: background,
        anchor: anchor,
        children: /*#__PURE__*/jsx(Div, {
          spacingTop: 5,
          children: /*#__PURE__*/jsx(AnimationContainer, {
            $hoverColor: animationColor,
            children: /*#__PURE__*/jsx(TwoColumnLayout, {
              mainContentPosition: layout,
              mainContent: textContent,
              mainContentPercentage: 34,
              secondaryContent: imageContent,
              secondaryContentPercentage: 66,
              mainContentPositionOnWrap: "bottom",
              wrapOnTablet: true
            })
          })
        })
      })
    })
  });
}
const IMAGE_CLASS = 'featured-image';
const HOVER_COLORS = {
  background: 'background',
  primary: 'primary'
};
const AnimationContainer = styled(Div)`
  display: contents;

  &:hover {
    h1 {
      color: ${({
  $hoverColor
}) => colorToVariable(HOVER_COLORS[$hoverColor])};
    }
  }
`;
export { HeroFeaturedEditorial };
//# sourceMappingURL=HeroFeaturedEditorial.js.map
